module.exports = __webpack_public_path__ + "jo.8f719a67.svg";